var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "dottedMenu",
      class: [_vm.classNamePrefix, _vm.placementClass, _vm.activeClass],
      on: { mouseleave: _vm.onMouseLeaveWhole },
    },
    [
      _c("i", {
        staticClass: "fa fa-ellipsis-v",
        on: { click: _vm.toggleMenu },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "menu-slot" }, [
        _c(
          "div",
          { staticClass: "menu-slot__box", class: [_vm.color] },
          [
            _vm._t("default", function () {
              return [
                _c("button", { staticClass: "menu-btn" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("addOption")) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("button", { staticClass: "menu-btn" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("deleteOption")) +
                      "\n        "
                  ),
                ]),
              ]
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }